import { Activity } from '../shared';
import { TenantNotificationEvent } from '../sockets';

export interface ClaimActivityRequest {
    notification?: TenantNotificationEvent;
    activities: Activity[];
}

export interface ClaimActivities {
    remote: Activity[];
    local: Activity[];
}

export const emptyClaimActivities = {
    remote: [],
    local: []
}